import React, {
  ChangeEvent,
  CSSProperties,
  useEffect,
  useRef,
  useState,
} from 'react'
import {
  ExternalProfileType,
  UpdateProfileType,
} from '../../containers/SignInPage/types'
import { AddressSuggestions, DaDataAddressSuggestion } from 'react-dadata'
import $ from 'jquery'
import isURL from 'validator/lib/isURL'
import { dadataDots } from '../../utils/helpers'

// Styles
import './styles.scss'

// Icons
import IconEdit from './images/iconEdit'
import IconSave from '../AvatarEditBlock/images/iconSave'
import IconCancel from '../AvatarEditBlock/images/iconCancel'
import IconSocial from './images/iconSocial'
import IconAdd from './images/iconAdd'
import IconRemove from './images/iconRemove'

export default ({
  style,
  profile,
  onSave,
}: {
  style?: CSSProperties
  profile: ExternalProfileType
  onSave: (data: UpdateProfileType) => void
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [region, setRegion] = useState<DaDataAddressSuggestion | undefined>()
  const [location, setLocation] = useState<
    DaDataAddressSuggestion | undefined
  >()
  const [social, setSocial] = useState<string[]>([''])
  const [socialUnValidate, setSocialUnValidate] = useState<number[]>([])

  const { REACT_APP_DADATA_KEY } = process.env

  const suggestionsRegionRef = useRef<AddressSuggestions>(null)
  const suggestionsLocationRef = useRef<AddressSuggestions>(null)

  useEffect(() => {
    $('.about-edit-block').on('DOMNodeInserted', function (e) {
      if ($(e.target).attr('class') === 'react-dadata__suggestions-outer') {
        $(e.target).parent().find('div:first-child').addClass('active')
      }
    })

    $('.about-edit-block').on('DOMNodeRemoved', function (e) {
      if ($(e.target).attr('class') === 'react-dadata__suggestions-outer') {
        $(e.target).parent().find('div:first-child').removeClass('active')
      }
    })
  }, [])

  const handleRemoveUnValidateSocial = (index: number) => {
    const findIndexUnValidate = socialUnValidate.indexOf(index)
    if (findIndexUnValidate !== -1) {
      socialUnValidate.splice(findIndexUnValidate, 1)
      setSocialUnValidate([...socialUnValidate])
    }
  }

  const onChangeSocial = (
    event: ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    handleRemoveUnValidateSocial(index)
    const copySocial = [...social]
    copySocial[index] = event.currentTarget.value
    setSocial([...copySocial])
  }

  const handleRemoveSocial = (index: number) => {
    handleRemoveUnValidateSocial(index)
    const copySocial = [...social]
    copySocial.splice(index, 1)
    setSocial([...copySocial])
  }

  const initialDefaultValues = () => {
    if (profile.social_links && profile.social_links.length) {
      setSocial([...profile.social_links])
    }
    if (suggestionsLocationRef.current) {
      suggestionsLocationRef.current.setInputValue(
        profile.address?.location || ''
      )
    }
    if (suggestionsRegionRef.current) {
      suggestionsRegionRef.current.setInputValue(profile?.address?.region || '')
    }
  }

  useEffect(() => {
    if (profile) {
      initialDefaultValues()
    }
  }, [profile])

  const handleSave = () => {
    const unValidateUrls: number[] = []
    social.forEach((url, index) => {
      if (!isURL(url) && url.length) {
        unValidateUrls.push(index)
      }
    })
    if (unValidateUrls.length) {
      setSocialUnValidate([...unValidateUrls])
    } else {
      onSave({
        external_profile: {
          address: {
            country: 'Россия',
            region: region?.value,
            location: location?.value,
          },
          social_links: social.filter(social => social),
        },
      })
      setIsEdit(false)
    }
  }

  function formatSelected(suggestion: { value: string }): string {
    return dadataDots(suggestion.value)
  }

  return (
    <div style={style} className={'about-edit-block'}>
      <div className={'about-edit-block__header'}>
        <div className={'title'}>Информация обо мне</div>
        <div className={'about-edit-block__header-nav'}>
          {isEdit ? (
            <>
              <IconSave onClick={handleSave} style={{ marginRight: 9 }} />
              <IconCancel
                onClick={() => {
                  setIsEdit(false)
                  setSocialUnValidate([])
                  initialDefaultValues()
                }}
              />
            </>
          ) : (
            <IconEdit onClick={() => setIsEdit(true)} />
          )}
        </div>
      </div>
      <div className={'about-edit-block__column'}>
        <div className={'about-edit-block__column-item'}>
          <div className={'label'}>Страна:</div>
          <div className={'input'}>
            <input disabled={true} value={'Россия'} />
          </div>
        </div>
        <div className={'about-edit-block__column-item'}>
          <div className={'label'}>Регион:</div>
          <div className={'input'}>
            <AddressSuggestions
              token={REACT_APP_DADATA_KEY}
              value={region}
              onChange={value => {
                value!.value = formatSelected({
                  value: value!.value,
                })
                setRegion(value)
              }}
              filterFromBound={'region'}
              filterToBound={'region'}
              ref={suggestionsRegionRef}
              renderOption={value => formatSelected(value)}
              inputProps={{
                disabled: !isEdit,
              }}
            />
          </div>
        </div>
        <div className={'about-edit-block__column-item'}>
          <div className={'label'}>
            Населенный
            <br />
            пункт:
          </div>
          <div className={'input'}>
            <AddressSuggestions
              token={REACT_APP_DADATA_KEY}
              value={location}
              onChange={value => {
                value!.value = formatSelected({
                  value:
                    value!.data.settlement_with_type ||
                    value!.data.city_with_type ||
                    '',
                })
                setLocation(value)
                const region = value?.data.region_with_type
                if (region) {
                  const regionValue = Object.assign({}, value)
                  regionValue!.value = dadataDots(region)
                  setRegion(regionValue)
                }
              }}
              filterFromBound={'city'}
              filterToBound={'settlement'}
              ref={suggestionsLocationRef}
              renderOption={value => formatSelected(value)}
              inputProps={{
                disabled: !isEdit,
              }}
            />
          </div>
        </div>
        <div className={'about-edit-block__column-item'}>
          <div style={{ marginRight: 7 }} className={'label'}>
            Соц сети:
          </div>
          <IconSocial style={{ marginRight: 7 }} />
          <div className={'input'}>
            <input
              disabled={!isEdit}
              onChange={event => onChangeSocial(event, 0)}
              value={social[0]}
              style={
                socialUnValidate.indexOf(0) !== -1
                  ? { background: '#FCE5DF' }
                  : {}
              }
            />
          </div>
        </div>
        {social
          ?.filter((_, index) => index)
          .map((item, index) => (
            <div
              key={`social_${index}`}
              className={'about-edit-block__column-item'}
            >
              <div style={{ marginRight: 7 }} className={'label'} />
              <IconSocial style={{ marginRight: 7 }} />
              <div className={'input'}>
                <input
                  disabled={!isEdit}
                  value={item}
                  onChange={event => onChangeSocial(event, index + 1)}
                  style={
                    socialUnValidate.indexOf(index + 1) !== -1
                      ? { background: '#FCE5DF' }
                      : {}
                  }
                />
              </div>
              {isEdit ? (
                <button
                  className={'remove'}
                  onClick={() => handleRemoveSocial(index + 1)}
                >
                  <IconRemove />
                </button>
              ) : null}
            </div>
          ))}
        {isEdit ? (
          <div className={'about-edit-block__column-item'}>
            <div style={{ marginRight: 10 }} className={'label'} />
            <div className={'input'}>
              <button
                className={'add'}
                onClick={() => {
                  social.push('')
                  setSocial([...social])
                }}
              >
                Добавить еще <IconAdd />
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
